module.exports = __webpack_public_path__ + "img/guerrico.83ce132b.jpg";